// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3TmWE","left":"InfoRow_left__aS4hX"};